import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/ValuesOne";
import BlockFour from "../components/block/BlockFour";
import BlockOne from "../components/block/BlockOne";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.gallery?.[12]}`}
        />
        <BlockFour
            title={rpdata?.dbSlogan?.[3]?.slogan}
            text={rpdata?.dbHome?.[1]?.text}
            image1={rpdata?.gallery?.[4]}
            image2={rpdata?.gallery?.[7]}
            image3={rpdata?.gallery?.[5]}
          />
        <ValuesOne image={rpdata?.gallery?.[19]} />

        <BlockOne
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image={rpdata?.gallery?.[31]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
